//export const STATUS_DONE = 'ĐÃ NỘP BÀI';
export const STATUS_FINISHED = 'ĐÃ HOÀN THÀNH';
export const STATUS_NOTYET = 'CHƯA LÀM';
export const STATUS_LATED = 'TRỄ TIẾN ĐỘ';
export const STATUS_DELAY = 'CHẬM TIẾN ĐỘ';
export const STATUS_OK = 'OK';
